import React, { Component } from 'react';

import memoize from 'lodash/memoize';
import '../sass/customerAccount.css';
import CallApi from './../../../utils/CallApi';
import isSuiteAccount from './../../../utils/isSuiteAccount';
import TableLoader from './../../../common/tableloader/TableLoader';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import RemoveIcon from '@material-ui/icons/Remove';
import { a } from 'react-router';
import CarteImg from '../img/solde_plein@2x.png';
import ImgRemove from '../img/delete.png';
import ImgSettings from '../img/settings-white-icon.png';
import ImgSearch from '../img/search-icon.png';
import ImgTrash from '../img/trash.png';
import ImgPencil from '../img/pencil.png';
import ImgFilter from '../img/filter-icon.png';
import ImgStats from '../img/stats-icon.png';
import ImgCircleCross from '../img/cross-circle-blue1.png';
import removeAccents from 'remove-accents';
import { connect } from 'react-redux';
import config from '../../../utils/config';
import priceFormatting from '../../../utils/priceFormatting';
import { addFlashMessage } from '../../../common/flashMessage/actions/flashMessages';
import Clusterize from '../components/Clusterize';
import ModalExport from '../components/ModalExport';
import axios from 'axios';
import { I18n } from 'react-redux-i18n';
import A_B_Tester from '../../../components/A_B_Tester';
import ModalHistory from '../components/ModalHistory';
import ModalEmails from '../components/ModalEmails';
import ModalSettings from '../components/ModalSettings';
import ModalAccountForm from '../components/ModalAccountForm';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import StatsFilters from '../components/StatsFilters';
import TableFilters from '../components/TableFilters';
import KeyFigures from '../components/KeyFigures';
import ModalDownloadHistory from '../components/ModalDownloadHistory';
import DownloadSvg from '../svg/DownloadSvg';
import { Text } from '@capps/laddition-storybook';

const language = window.navigator.language;

// Libellés d'affichage des champs arbitrables lors d'une fusion. La liste des champs réellement
// proposés vient du back (diffFields de /customers/merge/preview) : rien n'est décidé ici.
const MERGE_FIELD_LABELS = {
	lastname: 'Nom',
	firstname: 'Prénom',
	email: 'E-mail',
	details_phone: 'Téléphone',
	address: 'Adresse',
	company: 'Société',
	note: 'Note',
};

// Les notes peuvent être longues : on les tronque à l'affichage uniquement (la valeur envoyée au
// back reste entière, c'est elle qui permet de retrouver la fiche source).
const MERGE_OPTION_MAX_LENGTH = 120;

class CustomerAccount extends Component {
	constructor(props) {
		super(props);
		this.state = {
			listAccounts: [],
			listAccountsFiltered: [],
			searchValue: '',
			loading: true,
			resetSearch: false,
			idOrderedBy: '',
			orderDirection: 'ASC',
			openExportModal: false,
			openExportHistory: false,
			openDownloadHistory: false,
			displayKeyFigures: true,
			allUsers: [],
			paymentTypes: [],
			openEmails: false,
			openSettings: false,
			selectedRows: [],
			selectAll: false,
			modalOpen: false,
			restoreModalOpen: false,
			restoreTargetId: null,
			// L+ Suite : déterminé par la version de caisse (2.x et plus), demandé au serveur.
			isSuite: false,
			// Établissement sélectionné (multi uniquement) ; null = tous.
			selectedCompanyId: null,
			mergeModalOpen: false,
			mergeCandidates: [],
			mergeDiffFields: [],
			mergeChoices: {},
			mergeDiffNames: [],
			mergeMasterName: '',
			openAccountForm: false,
			selectedAccountData: null,
			hasBalance: false,
			isFiltered: false,
			selectedCol: [],
			columnsVisible: {
				visit: false,
				order_average: false,
				guest_average: false,
				nb_guests: false,
				turnover: false,
				discount: false,
				offered: false,
				total: false,
			},
			activeFilterIds: [],
		};

		this.filtersData = [
			{
				label: I18n.t('customerAccount.balance'),
				options: [
					{ id: 'customers_debit_balance', label: I18n.t('customerAccount.customersDebitBalance'), filter: (account) => account.account_details.balance < 0 },
					{ id: 'customers_zero_balance', label: I18n.t('customerAccount.customersZeroBalance'), filter: (account) => account.account_details.balance === 0 },
					{ id: 'customers_credit_balance', label: I18n.t('customerAccount.customersCreditBalance'), filter: (account) => account.account_details.balance > 0 },
				],
			},
			{
				label: I18n.t('customerAccount.informations'),
				options: [
					{ id: 'customers_phone_number_entered', label: I18n.t('customerAccount.phoneNumberEntered'), filter: account => account.customer_infos.details_phone },
					{ id: 'customers_email_entered', label: I18n.t('customerAccount.emailEntered'), filter: account => account.customer_infos.details_email },
					{ id: 'customers_without_email_or_phone', label: I18n.t('customerAccount.withoutEmailOrPhone'), filter: account => !account.customer_infos.details_phone && !account.customer_infos.details_email },
				],
			},
			{
				label: I18n.t('customerAccount.visits'),
				options: [
					{ id: 'customers_no_visit', label: I18n.t('customerAccount.noVisit'), filter: account => account.account_details.visit === 0 },
					{ id: 'customers_1_and_10_visits', label: I18n.t('customerAccount.between1And10Visits'), filter: account => account.account_details.visit >= 1 && account.account_details.visit <= 10, },
					{ id: 'customers_11_and_50_visits', label: I18n.t('customerAccount.between11And50Visits'), filter: account => account.account_details.visit >= 11 && account.account_details.visit <= 50, },
					{ id: 'customers_51_and_100_visits', label: I18n.t('customerAccount.between51And100Visits'), filter: account => account.account_details.visit >= 51 && account.account_details.visit <= 100, },
					{ id: 'customers_credit_more_than_100_visits', label: I18n.t('customerAccount.moreThan100Visits'), filter: account => account.account_details.visit > 100 },
				],
			},
			{
				label: I18n.t('customerAccount.accountType'),
				options: [
					{ id: 'customers_open_slate', label: I18n.t('customerAccount.openSlate'), filter: account => account.type === 0 },
					{ id: 'customers_pre_loaded_account', label: I18n.t('customerAccount.preLoadedAccount'), filter: account => account.type === 1 },
				],
			},
		];

		this.headersLabels = [
			{
				id: 'lastname',
				cssClass: 'big',
				field: 'lastname',
				childField: null,
				label: `${I18n.t('customerAccount.firstAndLastName')}`,
			},
			{
				id: 'details_email',
				cssClass: 'big',
				field: 'customer_infos',
				childField: 'details_email',
				label: `${I18n.t('customerAccount.email')}`,
			},
			{
				id: 'details_phone',
				cssClass: 'big',
				field: 'customer_infos',
				childField: 'details_phone',
				label: `${I18n.t('customerAccount.phoneNumber')}`,
			},
			{
				id: 'adress',
				cssClass: 'big',
				field: 'customer_infos',
				childField: 'adress',
				label: `${I18n.t('customerAccount.address')}`,
			},
			{
				id: 'customer_company_id',
				cssClass: 'big',
				field: 'customer_infos',
				childField: 'customer_company_id',
				label: `${I18n.t('customerAccount.siren')}`,
			},
			{
				id: 'company_name',
				cssClass: 'big',
				field: 'companies',
				childField: 'company_name',
				label: `${I18n.t('customerAccount.companyName')}`,
			},
			{
				id: 'balance',
				cssClass: 'small',
				field: 'account_details',
				childField: 'balance',
				label: `${I18n.t('customerAccount.balance')}`,
			},
			{
				id: 'visit',
				cssClass: 'small',
				field: 'account_details',
				childField: 'visit',
				label: `${I18n.t('customerAccount.visit')}`,
			},
			{
				id: 'order_average',
				cssClass: 'small',
				field: 'account_details',
				childField: 'order_average',
				label: `${I18n.t('customerAccount.order_average')}`,
			},
			{
				id: 'guest_average',
				cssClass: 'small',
				field: 'account_details',
				childField: 'guest_average',
				label: `${I18n.t('customerAccount.guest_average')}`,
			},
			{
				id: 'nb_guests',
				cssClass: 'small',
				field: 'account_details',
				childField: 'nb_guests',
				label: `${I18n.t('customerAccount.nb_guests')}`,
			},
			{
				id: 'turnover',
				cssClass: 'small',
				field: 'account_details',
				childField: 'turnover',
				label: `${I18n.t('customerAccount.turnover')}`,
			},
			{
				id: 'discount',
				cssClass: 'small',
				field: 'account_details',
				childField: 'discount',
				label: `${I18n.t('customerAccount.discount')}`,
			},
			{
				id: 'offered',
				cssClass: 'small',
				field: 'account_details',
				childField: 'offered',
				label: `${I18n.t('customerAccount.offered')}`,
			},
			{
				id: 'total',
				cssClass: 'small',
				field: 'account_details',
				childField: 'total',
				label: `${I18n.t('customerAccount.turnoverDiscountOffered')}`,
			},
		];
	}

	componentDidMount() {
		isSuiteAccount().then(isSuite => this.setState({ isSuite }));
		this.getListCustomerAccounts();
		this.getAllUsers();
		this.getAllPaymentTypes();
		this.checkEspaceClientGroup();
		this.getDisplayKeyFigures();
	}

	getDisplayKeyFigures = async () => {
		try {
			const res = await CallApi('GET', 'customer-account/getVariablesServer', '', {
				keys: ['ca_display_key_figures'],
			});
			const value = res && res[0] ? res[0].ca_display_key_figures : undefined;
			// key figures are displayed by default (setting never set yet)
			this.setState({ displayKeyFigures: value !== '0' });
		} catch (e) {
			this.setState({ displayKeyFigures: true });
		}
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevState.searchValue !== this.state.searchValue) {
			window.sessionStorage.setItem('searchValue', this.state.searchValue);
		}

		if (
			prevState.listAccounts.length !== this.state.listAccounts.length &&
			window.sessionStorage.getItem('searchValue') !== 'null'
		) {
			const searchValueStorage =
				window.sessionStorage.getItem('searchValue') !== 'null'
					? window.sessionStorage.getItem('searchValue')
					: '';
			this.setState(
				{
					searchValue: searchValueStorage,
					loading: true,
				},
				() => {
					this.filterAccounts(searchValueStorage);
				}
			);
		}

		if (prevProps.auth.user !== this.props.auth.user) {
			this.checkEspaceClientGroup();
		}
	}

	getListCustomerAccounts = async () => {
		try {
			const accountsList = await CallApi('GET', 'customer-account', '', '');
			this.setState(
				{
					listAccounts: accountsList,
					listAccountsFiltered: accountsList,
					loading: false,
				},
				() => {
					// Après un re-fetch (fusion, restauration, mise à jour via la modale), on réapplique
					// TOUT le contexte d'affichage : recherche, filtres de la barre et établissement
					// sélectionné. Sans ça la liste repart complète et l'utilisateur perd son filtrage.
					// filterAccounts relit this.state.listAccounts (déjà posé ici) et re-fetch les
					// fiches supprimées correspondantes s'il y a une recherche.
					this.filterAccounts(this.state.searchValue);
				}
			);
		} catch (e) {
			this.props.addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue',
				persistent: false,
			});
		}
	};

	deleteSelectedAccounts = async customers => {
		// On NE capture PAS ici : si le back refuse (ex. compte avec solde, cf. deleteCustomersAccounts),
		// l'erreur doit remonter à handleDelete pour afficher un vrai message d'échec au lieu d'un faux
		// "succès".
		await CallApi('POST', 'customer-account/customers/removed', '', {
			customers,
		});
	};

	getAllUsers = async () => {
		try {
			const getUsers = await CallApi('GET', 'user/users', '', '');

			this.setState({ allUsers: getUsers[0] });
		} catch (error) {
			console.log(error);
			this.props.addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue',
				persistent: false,
			});
		}
	};

	checkEspaceClientGroup() {
		const user = this.props.auth.user;
		if (user && user.groups) {
			const hasEspaceClientGroup = user.groups.some(
				group => group.name === 'espace_client'
			);
			this.setState({ hasEspaceClientGroup });
		}
	}

	getAllPaymentTypes = async () => {
		try {
			const getPaymentTypes = await CallApi('GET', 'user/paymentTypes', '', '');
			this.setState({ paymentTypes: getPaymentTypes[0] });
		} catch (error) {
			console.log(error);
			this.props.addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue',
				persistent: false,
			});
		}
	};

	searchAccounts = e => {
		e.preventDefault();
		const searchValue = e.target.value;
		this.setState({ searchValue, loading: true }, () => {
			setTimeout(() => {
				this.filterAccounts(searchValue);
			}, 500);
		});
	};

	setOrderTable = (e, field, childField, id) => {
		e.preventDefault();
		this.setState(
			(prevState, props) => ({
				loading: true,
				idOrderedBy: id,
				orderDirection:
					prevState.idOrderedBy === id && prevState.orderDirection === 'ASC'
						? 'DESC'
						: 'ASC',
			}),
			() => {
				setTimeout(
					() => this.orderTable(this.state.listAccounts, field, childField),
					500
				);
			}
		);
	};

	orderTable = (accountList, field, childField) => {
		const sort_by = (field, fieldInObject, reverse = 'ASC', primer) => {
			const key = function (x) {
				const val =
					fieldInObject !== null && x[field.toString()]
						? field === 'companies'
							? x[field.toString()].length > 1
								? 'ALL'
								: x[field.toString()][0][fieldInObject]
							: x[field.toString()][fieldInObject]
						: x[field];
				return primer ? primer(val) : val;
			};

			const order = reverse === 'ASC' ? 1 : -1;
			return function (a, b) {
				return (
					(a = key(a) === null ? '' : key(a)),
					(b = key(b) === null ? '' : key(b)),
					order * ((a > b) - (b > a))
				);
			};
		};

		const sortedData = accountList[0].sort(
			sort_by(field, childField, this.state.orderDirection, a =>
				typeof a === 'string' ? a.toUpperCase() : a
			)
		);

		this.setState({
			loading: false,
			listAccountsFiltered: [sortedData],
		});
	};

	getRemovedAccounts = async searchValue => {
		try {
			const res = await CallApi(
				'GET',
				'customer-account/customer/searchRemoved',
				'',
				{ q: searchValue }
			);
			const datas = res && res[0] && res[0].success ? res[0].datas : [];
			return (datas || []).map(account => ({ ...account, removed: true }));
		} catch (error) {
			console.error('Error fetching removed accounts:', error);
			return [];
		}
	};

	handleCompanyChange = event => {
		const value = event.target.value;
		this.setState(
			{ selectedCompanyId: value === 'all' ? null : value },
			() => this.filterAccounts(this.state.searchValue)
		);
	};

	filterAccounts = async (searchValue) => {
		const { listAccounts, activeFilterIds } = this.state;

		const filtersToApply = this.filtersData
			.flatMap((group) =>
				activeFilterIds.map(
					(id) => group.options.find((option) => option.id === id)?.filter
				)
			)
			.filter(Boolean);

		const { selectedCompanyId } = this.state;

		const accountsListFiltered = (listAccounts || []).flat().filter((account) => {
			const search = account?.search?.toLowerCase() || '';
			const searchValueLower = searchValue?.toLowerCase() || '';

			// Une fiche peut relever de plusieurs établissements : elle apparaît dès que l'un d'eux
			// correspond à la sélection.
			const matchesCompany =
				!selectedCompanyId ||
				(account.companies || []).some(
					company => String(company.id) === String(selectedCompanyId)
				);

			return (
				matchesCompany &&
				(!searchValue || search.includes(searchValueLower)) &&
				(filtersToApply.length === 0 || filtersToApply.some((filterFunction) => filterFunction(account)))
			);
		});

		let combinedList = accountsListFiltered;

		if (searchValue) {
			const removedAccounts = await this.getRemovedAccounts(searchValue);
			const existingIds = new Set(accountsListFiltered.map(account => account.id));
			const dedupedRemovedAccounts = removedAccounts.filter(
				account => !existingIds.has(account.id)
			);
			combinedList = [...accountsListFiltered, ...dedupedRemovedAccounts];
		}

		this.setState({
			loading: false,
			listAccountsFiltered: [combinedList],
			selectedRows: [],
			selectAll: false,
		});
	};

	handleModalExport = e => {
		this.setState({ openExportModal: true });
	};

	handleResetClick = e => {
		e.preventDefault();
		this.setState(
			{
				searchValue: '',
				resetSearch: true,
				loading: true,
				listAccountsFiltered: this.state.listAccounts,
			},
			() => {
				this.filterAccounts('');
				this.setState({ loading: false });
			}
		);
	};

	handleClearFilters = () => {
		this.setState(
			{
				isFiltered: false,
				activeFilterIds: [],
				listAccountsFiltered: this.state.listAccounts,
			},
			() => {
				this.filterAccounts(this.state.searchValue);
				this.setState({ loading: false });
			}
		);
	};

	// Clé de LIGNE. Un même contact présent sur deux établissements donne deux lignes portant le même
	// `id` (contact.id) : la sélection s'appuie donc sur uniq_id_customer (id_customer-id_company),
	// sinon cocher l'une cocherait l'autre. Repli sur l'id pour les écrans qui ne le fournissent pas.
	rowKey = account => (account && account.uniq_id_customer) || (account && account.id);

	// Fiches correspondant aux lignes sélectionnées.
	selectedAccounts = () => {
		const accounts = (this.state.listAccountsFiltered || []).flat();
		return this.state.selectedRows
			.map(key => accounts.find(account => this.rowKey(account) === key))
			.filter(Boolean);
	};

	// Identifiants de CONTACT à envoyer à l'API. Dédoublonnés : deux lignes d'établissements
	// différents peuvent désigner le même contact.
	selectedCustomerIds = () => [
		...new Set(this.selectedAccounts().map(account => account.id)),
	];

	// Fiches sélectionnées avec leur base d'établissement : suppression et restauration s'y appliquent
	// ligne par ligne, une sélection pouvant couvrir plusieurs sites.
	selectedCustomers = () =>
		this.selectedAccounts().map(account => ({
			id: account.id,
			companyDbName: (account.companies || [])[0]?.company_db_name,
		}));

	// Bases des établissements des lignes sélectionnées : en master, les fiches ne vivent que dans
	// les bases filles. C'est le back qui décide quoi en faire (dont refuser deux établissements).
	selectedCompanyDbNames = () => [
		...new Set(
			this.selectedAccounts()
				.map(account => (account.companies || [])[0]?.company_db_name)
				.filter(Boolean)
		),
	];

	handleCheckboxChange = id => {
		this.setState(prevState => {
			const isAlreadySelected = prevState.selectedRows.includes(id);
			let newSelectedRows;

			if (isAlreadySelected) {
				newSelectedRows = prevState.selectedRows.filter(rowId => rowId !== id);
			} else {
				newSelectedRows = [...prevState.selectedRows, id];
			}

			const selectedAccount = newSelectedRows.length === 1
				? prevState.listAccountsFiltered
					.flat()
					.find(account => this.rowKey(account) === newSelectedRows[0])
				: null;

			const hasBalance =
				(!isAlreadySelected && selectedAccount?.account_details?.balance > 0) ||
				selectedAccount?.account_details?.balance < 0;

			return {
				selectedRows: newSelectedRows,
				selectedAccountData: selectedAccount,
				hasBalance: hasBalance,
			};
		});
	};

	handleSelectAll = () => {
		const data = this.state.listAccountsFiltered.flat();
		// "Tout sélectionner" prend toutes les fiches NON supprimées (les supprimées ne sont jamais
		// bulk-éditables). On ne filtre PLUS sur le solde ici — c'est cohérent avec la sélection
		// individuelle qui autorise un compte à solde. La sécurité "pas de suppression en masse avec
		// solde" reste portée par hasBalance : si une fiche sélectionnée a un solde, le bouton
		// "Supprimer" se masque (cf. rendu `{!this.state.hasBalance && ...}`).
		const selectableData = data.filter(account => !account.removed);

		const selectAll = !this.state.selectAll;
		const newSelectedRows = selectAll ? selectableData.map(row => this.rowKey(row)) : [];

		const hasBalance =
			selectAll &&
			selectableData.some(account => {
				const balance = account.account_details?.balance;
				return balance !== 0 && balance !== null && balance !== undefined;
			});

		this.setState({
			selectedRows: newSelectedRows,
			selectAll: selectAll,
			hasBalance: hasBalance,
		});
	};

	isRowSelected = id => {
		return this.state.selectedRows.includes(id);
	};

	// Vrai si la sélection courante contient au moins une fiche déjà supprimée : dans ce cas on masque
	// le bouton "Supprimer" (supprimer une fiche déjà supprimée ne sert à rien).
	hasRemovedInSelection = () => {
		return this.selectedAccounts().some(account => account.removed);
	};

	// Vrai si AU MOINS une fiche sélectionnée a un solde. Calculé à la volée depuis la sélection (le
	// state hasBalance n'était fiable qu'en sélection unique) → masque le bouton "Supprimer" dès qu'un
	// compte à solde est dans la sélection, même en multi-sélection (le back refuse la suppression avec
	// solde).
	hasBalanceInSelection = () => {
		return this.selectedAccounts().some(account => {
			const balance = account?.account_details?.balance;
			return balance !== 0 && balance !== null && balance !== undefined;
		});
	};

	// Vrai si la sélection (non vide) ne contient QUE des fiches supprimées : dans ce cas on propose un
	// bouton d'action "Restaurer" (bulk) à la place de "Supprimer".
	allSelectedRemoved = () => {
		const selected = this.selectedAccounts();
		return selected.length > 0 && selected.every(account => account.removed);
	};

	handleCloseRestoreModal = () => {
		this.setState({ restoreModalOpen: false, restoreTargetId: null });
	};

	// Clic délégué sur une ligne (les lignes sont du HTML statique via Clusterize/renderToString, donc
	// pas d'onClick React). Fiche supprimée → modale de restauration ; fiche active → navigation détail.
	handleRowClick = ({ type, id, url }) => {
		if (type === 'restore') {
			this.setState({ restoreModalOpen: true, restoreTargetId: id });
		} else if (type === 'navigate' && url) {
			window.location.assign(url);
		}
	};

	// Restauration unitaire déclenchée par le clic sur une ligne supprimée (removed=0 sur _dim_customer
	// ET contact côté back). Même refresh que le bulk : re-fetch + réapplication de la recherche courante.
	handleConfirmRestore = async () => {
		const rowKey = this.state.restoreTargetId;
		this.setState({ restoreModalOpen: false, restoreTargetId: null });
		if (!rowKey) return;

		const account = (this.state.listAccountsFiltered || [])
			.flat()
			.find(a => this.rowKey(a) === rowKey);
		if (!account) return;

		try {
			await CallApi('PUT', 'customer-account/customer/restore', '', {
				customerId: account.id,
				companyDbName: (account.companies || [])[0]?.company_db_name,
			});
			await this.getListCustomerAccounts();
			this.props.addFlashMessage({
				type: 'success',
				text: 'La fiche client a été restaurée avec succès.',
				persistent: false,
			});
		} catch (error) {
			console.error('Error during restore :', error);
			this.props.addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue lors de la restauration.',
				persistent: false,
			});
		}
	};

	handleBulkRestore = async () => {
		const customers = this.selectedCustomers();
		try {
			await CallApi('PUT', 'customer-account/customers/restore', '', {
				customers,
			});
			this.setState({ selectedRows: [], selectAll: false });
			// Même refresh que delete/restore : re-fetch + réapplication de la recherche courante (les
			// fiches restaurées repassent en removed=0 et sortent donc du badge "Supprimé").
			await this.getListCustomerAccounts();
			this.props.addFlashMessage({
				type: 'success',
				text: 'Votre sélection a été restaurée avec succès.',
				persistent: false,
			});
		} catch (error) {
			console.error('Error during restore :', error);
			this.props.addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue lors de la restauration.',
				persistent: false,
			});
		}
	};

	// Clic sur "Fusionner" : c'est le back qui prépare tout (fiche maître retenue, valeurs de chaque
	// fiche, champs divergents, noms suspects) via /customers/merge/preview, et qui refuse la fusion le
	// cas échéant. Aucune de ces règles n'est répliquée ici : le front ne fait qu'afficher.
	// La modale de confirmation s'ouvre TOUJOURS (l'action est irréversible).
	handleMergeClick = async () => {
		const customerIds = this.selectedCustomerIds();
		try {
			const response = await CallApi(
				'POST',
				'customer-account/customers/merge/preview',
				'',
				{ customerIds, companyDbNames: this.selectedCompanyDbNames() }
			);
			const preview = (response && response[0]) || {};
			const candidates = preview.candidates || [];
			const diffFields = preview.diffFields || [];

			// Valeurs pré-cochées = celles de la fiche maître.
			const master = candidates.find(candidate => candidate.isMaster);
			const choices = {};
			diffFields.forEach(field => {
				choices[field] = master && master.fields ? master.fields[field] : '';
			});

			this.setState({
				mergeModalOpen: true,
				mergeCandidates: candidates,
				mergeDiffFields: diffFields,
				mergeChoices: choices,
				mergeDiffNames: preview.differentNames || [],
				mergeMasterName: preview.masterLabel || '',
			});
		} catch (error) {
			console.error('Error previewing merge :', error);
			this.props.addFlashMessage({
				type: 'danger',
				text:
					(error.response && error.response.data && error.response.data.message) ||
					'Une erreur est survenue lors de la préparation de la fusion.',
				persistent: false,
			});
		}
	};

	// Valeurs distinctes proposées pour un champ, dans l'ordre de sélection des fiches, avec le nom des
	// fiches qui les portent. La chaîne vide est une option comme une autre (affichée "(vide)"), pour
	// qu'effacer un champ sur la fiche maître reste un choix explicite.
	mergeFieldOptions = field => {
		const options = [];
		(this.state.mergeCandidates || []).forEach(candidate => {
			const value = (candidate.fields && candidate.fields[field]) || '';
			const existing = options.find(option => option.value === value);
			if (existing) existing.from.push(candidate.label);
			else options.push({ value, from: [candidate.label] });
		});
		return options;
	};

	handleMergeChoiceChange = (field, value) => {
		this.setState(prevState => ({
			mergeChoices: { ...prevState.mergeChoices, [field]: value },
		}));
	};

	// Fusion effective : le back repointe les documents vers la fiche maître, supprime les sources et
	// écrit les valeurs retenues (masterFields), le tout dans une seule transaction.
	// Même refresh que delete/restore.
	handleMerge = async () => {
		const customerIds = this.selectedCustomerIds();
		const masterFields = this.state.mergeChoices;
		this.setState({ mergeModalOpen: false });
		try {
			await CallApi('POST', 'customer-account/customers/merge', '', {
				customerIds,
				masterFields,
				companyDbNames: this.selectedCompanyDbNames(),
			});
			this.setState({ selectedRows: [], selectAll: false });
			await this.getListCustomerAccounts();
			this.props.addFlashMessage({
				type: 'success',
				text:
					'Les fiches client ont été fusionnées avec succès. Les statistiques de ventes des ' +
					'clients seront mises à jour lors de la prochaine synchronisation de la caisse.',
				persistent: false,
			});
		} catch (error) {
			console.error('Error during merge :', error);
			this.props.addFlashMessage({
				type: 'danger',
				text:
					(error.response && error.response.data && error.response.data.message) ||
					'Une erreur est survenue lors de la fusion.',
				persistent: false,
			});
		}
	};

	handleCloseMergeModal = () => {
		this.setState({
			mergeModalOpen: false,
			mergeCandidates: [],
			mergeDiffFields: [],
			mergeChoices: {},
		});
	};

	handleDelete = async () => {
		try {
			await this.deleteSelectedAccounts(this.selectedCustomers());

			this.setState({
				selectedRows: [],
				selectAll: false,
				modalOpen: false,
			});
			// Re-fetch complet plutôt qu'une suppression optimiste de l'affichage : la liste principale
			// (removed=0) ne contient plus les fiches supprimées, et getListCustomerAccounts réapplique la
			// recherche courante (qui re-fetch les supprimées). Ainsi une fiche qu'on vient de supprimer
			// réapparaît IMMÉDIATEMENT avec le badge "Supprimé" si un terme de recherche est actif — comme
			// après un F5 — au lieu de disparaître.
			await this.getListCustomerAccounts();
			this.props.addFlashMessage({
				type: 'success',
				text: 'Votre sélection a été supprimée avec succès.',
				persistent: false,
			});
		} catch (error) {
			console.error('Error during delete :', error);
			this.props.addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue lors de la supression.',
				persistent: false,
			});
		}
	};

	handleOpenModal = () => {
		this.setState({ modalOpen: true });
	};

	handleCloseModal = () => {
		this.setState({
			modalOpen: false,
		});
	};

	handleOpenModalWithData = () => {
		this.setState({
			openAccountForm: true,
		});
	};

	handleFormSuccess = async () => {
		try {
			await this.getListCustomerAccounts();
			this.setState({
				openAccountForm: false,
				selectedRows: [],
			});
			this.props.addFlashMessage({
				type: 'success',
				text: 'Le compte a été modifié avec succès.',
				persistent: false,
			});
		} catch (error) {
			console.error('Error during update :', error);
			this.props.addFlashMessage({
				type: 'danger',
				text: 'Une erreur est survenue lors de la mise à jour des informations.',
				persistent: false,
			});
		}
	};

	handleSelectionChange = (newSelectedCol) => {
		this.setState({ selectedCol: newSelectedCol });
	};

	handleColumnVisibilityChange = (columnId, isVisible) => {
    this.setState(prevState => ({
      columnsVisible: {
        ...prevState.columnsVisible,
        [columnId]: isVisible,
      },
    }));
  };

handleRowVisibilityChange = (id, isChecked) => {
	this.setState(
		(prevState) => {
			const updatedFilters = isChecked
				? [...prevState.activeFilterIds, id]
				: prevState.activeFilterIds.filter((filterId) => filterId !== id);

			const isFiltered = updatedFilters.length > 0;

			return { activeFilterIds: updatedFilters, isFiltered };
		},
		() => {
			this.filterAccounts(this.state.searchValue);
		}
	);
};


	exportCustomerData = async (
		startDate = '',
		endDate = '',
		route,
		userId = '',
		method,
		email
	) => {
		try {
			const customerAccountExport = await CallApi(
				method,
				`customer-account/${route}`,
				'',
				{
					startDate,
					endDate,
					email,
				}
			);

			if (customerAccountExport && customerAccountExport.length > 0) {
				let message =
					customerAccountExport[0].ok && customerAccountExport[0].data
						? I18n.t('lneExport.exportProcessing')
						: I18n.t('lneExport.noData');
				this.props.addFlashMessage({
					type: message.type,
					text: message,
					persistent: false,
				});
			}
		} catch (error) {
			console.log(error);
			this.props.addFlashMessage({
				type: 'error',
				text: "Une erreur s'est produite",
				persistent: true,
			});
			return error;
		}
	};

	createTableHeader = () => {
		return this.headersLabels
			.filter(head => {
				if (!this.props.isMultiCompany && head.id === 'company_name') {
					return false;
				}
				if (this.state.columnsVisible[head.id] === false) {
					return false;
				}
				return true;
			})
			.map(head => {
				return (
						<tr
							id="header_label"
							key={`${Math.floor(Math.random() * 100000)}`}
							className={`flex-row ${head.cssClass}`}
						>
							<th
								key={head.id}
								role="columnheader"
								onClick={e =>
									this.setOrderTable(e, head.field, head.childField, head.id)
								}
							>
								{head.label}
								{head.id !== this.state.idOrderedBy ? (
								<RemoveIcon />
							) : this.state.orderDirection === 'ASC' ? (
								<ArrowUpwardIcon />
							) : (
								<ArrowDownwardIcon />
							)}
							</th>
							
						</tr>
				);
			});
	};

	createAccountRow = () => {
		const data =
			this.state.searchValue || this.state.isFiltered
				? this.state.listAccountsFiltered.flat()
				: this.state.listAccountsFiltered.flat().slice(0, 100);
		const renderCompanies = companies => {
			return companies.length > 1 ? 'Tous' : companies[0].company_name;
		};

		if (data.length > 0) {
			return data.map(account => {
				const accountIds = account.companies.map(
					company => company.uniq_id_customer
				);
				const accountIdCompanies = account.companies.map(company => company.id);
				const nameRestaurantTmp =
					account.companies.length === 1
						? account.companies[0].company_name.split(' ').join('-')
						: '';
				const nameRestaurant = removeAccents(nameRestaurantTmp);

				// Une fiche SUPPRIMÉE n'est pas cliquable vers sa page détail (getOneCustomerAccount filtre
				// removed=0 → la page serait vide/cassée). On neutralise le lien : les <a href={url}> des
				// cellules deviennent non navigants. La modification/restauration passe par la case à
				// cocher + "Modifier" (modale).
				const url = account.removed
					? undefined
					: account.companies.length === 1
						? `customer-account/${accountIds}?id=${accountIdCompanies}`
						: `customer-account/${accountIds}`;

				return (
					<tr
						className="flex-table"
						role="rowgroup"
						key={account.id}
						style={{ cursor: 'pointer' }}
						data-restore-id={account.removed ? this.rowKey(account) : undefined}
						data-url={
							account.companies.length === 1
								? `/customer-account/${accountIds}?id=${accountIdCompanies}`
								: `/customer-account/${accountIds}`
						}>
						{/* Case à cocher affichée pour tous les comptes — même condition que l'en-tête
						    dans Clusterize, sinon les colonnes se décalent. */}
						<td
							className="flex-row check-box-cell"
							role="cell"
							onClick={e => e.stopPropagation()}>
							{/* Les lignes sont du HTML statique (renderToString) : la sélection passe par ce
							    data-id, lu par la délégation d'événement de Clusterize — les onChange React
							    ne sont pas branchés. Il doit donc porter la CLÉ DE LIGNE, pas l'id du contact. */}
							<input
								type="checkbox"
								data-id={this.rowKey(account)}
								checked={this.isRowSelected(this.rowKey(account))}
								onChange={() => this.handleCheckboxChange(this.rowKey(account))}
							/>
						</td>
						<td className="flex-row big" role="cell">
							<a href={url}>
								<span>{`${account.lastname || ''} ${
									account.firstname || ''
								}`}</span>
								{account.removed && (
									<span
										className="removed-badge"
										style={{
											display: 'inline-block',
											alignSelf: 'center',
											flex: '0 0 auto',
											marginLeft: 8,
											padding: '2px 6px',
											borderRadius: 4,
											fontSize: 11,
											lineHeight: 1.4,
											fontWeight: 'bold',
											whiteSpace: 'nowrap',
											color: '#fff',
											backgroundColor: '#d0021b',
											verticalAlign: 'middle',
										}}>
										{I18n.t('customerAccount.removedBadge')}
									</span>
								)}
							</a>
						</td>
						<td className="flex-row big" role="cell">
							<a href={url}>
								<span>{account.customer_infos?.details_email || ''}</span>
							</a>
						</td>
						<td className="flex-row big" role="cell">
							<a href={url}>
								<span>{account.customer_infos?.details_phone || ''}</span>
							</a>
						</td>
						<td className="flex-row big" role="cell">
							<a href={url}>
								<span>{account.customer_infos?.address || ''}</span>
							</a>
						</td>
						<td className="flex-row big" role="cell">
							<a href={url}>
								<span>{account.customer_infos?.customer_company_id || ''}</span>
							</a>
						</td>
						{this.props.isMultiCompany && (
							<td className="flex-row big" role="cell">
								<a href={url}>
									<span>
										{account.companies ? renderCompanies(account.companies) : ''}
									</span>
								</a>
							</td>
						)}
						<td className="flex-row small" role="cell">
							<a href={url}>
								<span>
									{account.account_details?.balance
										? priceFormatting(
												account.account_details.balance,
												'en',
												'EUR'
										  )
										: ''}
								</span>
							</a>
						</td>
						{this.state.columnsVisible.visit && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.visit || ''}</span>
								</a>
							</td>
						)}
						{this.state.columnsVisible.order_average && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.order_average || ''}</span>
								</a>
							</td>
						)}
						{this.state.columnsVisible.guest_average && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.guest_average || ''}</span>
								</a>
							</td>
						)}
						{this.state.columnsVisible.nb_guests && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.nb_guests || ''}</span>
								</a>
							</td>
						)}
						{this.state.columnsVisible.turnover && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.turnover || ''}</span>
								</a>
							</td>
						)}
						{this.state.columnsVisible.discount && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.discount || ''}</span>
								</a>
							</td>
						)}
						{this.state.columnsVisible.offered && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.offered || ''}</span>
								</a>
							</td>
						)}
						{this.state.columnsVisible.total && (
							<td className="flex-row small" role="cell">
								<a href={url}>
									<span>{account.account_details?.total || ''}</span>
								</a>
							</td>
						)}
					</tr>
				);
			});
		} else {
			return (
				<div id="empty-contact">
					<div id="error-box">
						<div className="face">
							<div className="eye" />
							<div className="eye right" />
							<div className="mouth sad" />
						</div>
						<div className="shadow move" />
						<p className="message">No account found</p>
					</div>
				</div>
			);
		}
	};

	selectFilter = () => {
		return (
			<div className="flex items-center">
				<div className="flex">
					<div className='flex items-center'>
						<img src={ImgStats} alt="Statistics" className="statistics" />
					</div>
					<StatsFilters
						label={I18n.t('customerAccount.displayStatistics')}
						onColumnVisibilityChange={this.handleColumnVisibilityChange}
					/>
				</div>
				<div className="flex filters-select">
					<div className='flex items-center'>
						<img src={ImgFilter} alt="Filter" className="filter" />
					</div>
					<TableFilters
						label={I18n.t('customerAccount.balance')}
						data={this.filtersData[0].options}
						activeFilterIds={this.state.activeFilterIds}
						onRowVisibilityChange={this.handleRowVisibilityChange}
					/>
					<TableFilters
						label={I18n.t('customerAccount.informations')}
						data={this.filtersData[1].options}
						activeFilterIds={this.state.activeFilterIds}
						onRowVisibilityChange={this.handleRowVisibilityChange}
					/>
					<TableFilters
						label={I18n.t('customerAccount.visits')}
						data={this.filtersData[2].options}
						activeFilterIds={this.state.activeFilterIds}
						onRowVisibilityChange={this.handleRowVisibilityChange}
					/>
					{this.state.isSuite &&
						<TableFilters
							label={I18n.t('customerAccount.accountType')}
							data={this.filtersData[3].options}
							activeFilterIds={this.state.activeFilterIds}
							onRowVisibilityChange={this.handleRowVisibilityChange}
						/>
					}
					{this.state.isFiltered && (
						<button
							className="reset-filters-btn"
							onClick={() => this.handleClearFilters()}>
							<img src={ImgCircleCross} alt="Close" className="cross-circle" />
							<Text className="button-img-text" color="main" variant="h6">{I18n.t('customerAccount.clearFilters')}</Text>
						</button>
					)}
				</div>
			</div>
		);
	};

	render() {
		const customerAccounts = this.state.listAccounts;
		const customerIds = customerAccounts.flat().map((item) => item.id);
		return (
			<div id="customer-account">
				<h3>{I18n.t('customerAccount.customerAccountTitle')}</h3>
				{this.state.displayKeyFigures && (
					<KeyFigures accounts={this.state.listAccounts} />
				)}
				<header>
					<div className="header-main">
						<div className="customer-header-left">{this.selectFilter()}</div>
						<div className="customer-header-action">
							<button
								type="button"
								onClick={() => this.setState({ openSettings: true })}
								className="filters-btn">
								<p>Paramètres</p>
								<img src={ImgSettings} alt="Settings" className="settings" />
							</button>
							<button
								type="button"
								onClick={() => this.setState({ openEmails: true })}
								className="filters-btn">
								<p>{I18n.t('customerAccount.invoiceEmails')}</p>
							</button>
							{/* { !this.state.isSuite &&
								<button
									className="btn-history"
									onClick={() => this.setState({ openExportHistory: true })}>
									Historique
								</button>
							} */}
							{/* <A_B_Tester
								featureFlag={'export-customer-account'}
								FeatureFlagComponent={
									<button
										className="header-export-btn"
										// onClick={this.handleModalExport}
									>
										{I18n.t('customerAccount.export')}
									</button>
								}
								DefaultComponent={null}
							/> */}
							<button
								type="button"
								onClick={() => this.setState({ openDownloadHistory: true })}
								className="filters-btn">
								<DownloadSvg className="download-icon" style={{ color: '#fff', marginRight: 6 }} />
								<p>{I18n.t('customerAccount.historyButton')}</p>
							</button>

							<div className="search-bar-account">
								{this.state.searchValue ? (
									<img
										src={ImgCircleCross}
										onClick={this.handleResetClick}
										className="remove"
										alt="img remove"
									/>
								) : (
									''
								)}
								<input
									type="text"
									placeholder={I18n.t('customerAccount.search')}
									value={this.state.searchValue ? this.state.searchValue : ''}
									onChange={this.searchAccounts}
								/>
								<div>
									<img src={ImgSearch} alt="Search" className="search" />
								</div>
							</div>
						</div>
					</div>
				</header>
				{this.props.isMultiCompany && (
					<div className="company-filter">
						<label htmlFor="company-filter-select">Établissement :</label>
						<select
							id="company-filter-select"
							value={this.state.selectedCompanyId || 'all'}
							onChange={this.handleCompanyChange}>
							<option value="all">Tous les établissements</option>
							{(this.props.companies || []).map(company => (
								<option key={company.id_company} value={company.id_company}>
									{company.company_name}
								</option>
							))}
						</select>
					</div>
				)}
				{this.state.selectedRows.length > 0 && (
					<div className="row-actions">
						<p>
							{this.state.selectedRows.length > 1
								? `${this.state.selectedRows.length} comptes clients sélectionnés`
								: `${this.state.selectedRows.length} compte client sélectionné`}
						</p>
						<div className="row-buttons">
							{/* Modifier reste réservé aux comptes L+ Suite. */}
							{this.state.selectedRows.length === 1 && this.state.isSuite && (
								<button
									className="btn-update"
									type="button"
									onClick={this.handleOpenModalWithData}>
									<p>Modifier</p>
									<img src={ImgPencil} alt="Update" className="pencil" />
								</button>
							)}
							{!this.hasBalanceInSelection() && !this.hasRemovedInSelection() && (
								<button
									className="btn-delete"
									type="button"
									onClick={this.handleOpenModal}>
									<p>Supprimer</p>
									<img src={ImgTrash} alt="Delete" className="trash" />
								</button>
							)}
							{this.allSelectedRemoved() && (
								<button
									className="btn-update"
									type="button"
									style={{ marginLeft: '1rem' }}
									onClick={this.handleBulkRestore}>
									<p>Restaurer</p>
								</button>
							)}
							{this.state.selectedRows.length >= 2 && !this.hasRemovedInSelection() && (
								<button
									className="btn-update"
									type="button"
									style={{ marginLeft: '1rem' }}
									onClick={this.handleMergeClick}>
									<p>Fusionner</p>
								</button>
							)}
						</div>
					</div>
				)}
				<main className="main_customer_account">
					<section>
						{this.state.loading ? (
							<TableLoader />
						) : this.state.listAccountsFiltered[0] &&
							this.state.listAccountsFiltered[0].length > 0 ? (
							<Clusterize
								rows={this.createAccountRow()}
								createTableHeader={this.createTableHeader()}
								isSuite={this.state.isSuite}
								selectAll={this.state.selectAll}
								handleSelectAll={this.handleSelectAll}
								onCheckboxChange={this.handleCheckboxChange}
								onRowClick={this.handleRowClick}
							/>
						) : (
							<div id="empty-contact">
								<div id="error-box">
									<div className="face">
										¨
										<div className="eye" />
										<div className="eye right" />
										<div className="mouth sad" />
									</div>
									<div className="shadow move" />
									<p className="message">
										{I18n.t('customerAccount.noAccountFound')}
									</p>
								</div>
							</div>
						)}
					</section>
				</main>

				<Dialog
					open={this.state.modalOpen}
					onClose={this.handleCloseModal}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description">
					<DialogTitle id="alert-dialog-title">
						Supprimer des comptes clients
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							Voulez-vous vraiment supprimer cette sélection de comptes clients
							?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleCloseModal}>Annuler</Button>
						<Button onClick={this.handleDelete} autoFocus>
							Valider
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.restoreModalOpen}
					onClose={this.handleCloseRestoreModal}
					aria-labelledby="restore-dialog-title"
					aria-describedby="restore-dialog-description">
					<DialogTitle id="restore-dialog-title">
						Restaurer une fiche client
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="restore-dialog-description">
							Voulez-vous restaurer cette fiche client ?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleCloseRestoreModal}>Non</Button>
						<Button onClick={this.handleConfirmRestore} autoFocus>
							Oui
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.mergeModalOpen}
					onClose={this.handleCloseMergeModal}
					aria-labelledby="merge-dialog-title"
					aria-describedby="merge-dialog-description">
					<DialogTitle id="merge-dialog-title">
						Fusionner des fiches client
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="merge-dialog-description">
							La fusion rattache les commandes, ventes et réservations des
							fiches sélectionnées à une seule fiche « maître », puis supprime
							les autres fiches. Cette action est irréversible.
						</DialogContentText>
						{this.state.mergeMasterName && (
							<DialogContentText style={{ marginTop: '0.75rem' }}>
								Les statistiques et le solde seront regroupés dans la fiche
								« {this.state.mergeMasterName} ».
							</DialogContentText>
						)}
						{this.state.mergeDiffNames.length > 0 && (
							<DialogContentText
								style={{ marginTop: '1rem', color: '#b26a00' }}>
								Attention : certains noms diffèrent (
								{this.state.mergeDiffNames.join(', ')}). Voulez-vous vraiment
								fusionner ces fiches client ?
							</DialogContentText>
						)}
						{this.state.mergeDiffFields.length > 0 && (
							<div style={{ marginTop: '1.25rem' }}>
								<DialogContentText>
									Ces informations diffèrent d'une fiche à l'autre. Choisissez
									celles à conserver sur la fiche maître :
								</DialogContentText>
								{this.state.mergeDiffFields.map(field => (
									<div key={field} style={{ marginTop: '0.75rem' }}>
										<strong>{MERGE_FIELD_LABELS[field] || field}</strong>
										{this.mergeFieldOptions(field).map(option => (
											<label
												key={`${field}-${option.value}`}
												style={{
													display: 'block',
													marginTop: '0.25rem',
													cursor: 'pointer',
												}}>
												<input
													type="radio"
													name={`merge-${field}`}
													checked={
														this.state.mergeChoices[field] === option.value
													}
													onChange={() =>
														this.handleMergeChoiceChange(field, option.value)
													}
													style={{ marginRight: '0.5rem' }}
												/>
												{option.value
													? option.value.length > MERGE_OPTION_MAX_LENGTH
														? `${option.value.slice(0, MERGE_OPTION_MAX_LENGTH)}…`
														: option.value
													: '(vide)'}
												<span style={{ color: '#888', marginLeft: '0.5rem' }}>
													({option.from.join(', ')})
												</span>
											</label>
										))}
									</div>
								))}
							</div>
						)}
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleCloseMergeModal}>Non</Button>
						<Button onClick={this.handleMerge} autoFocus>
							Oui
						</Button>
					</DialogActions>
				</Dialog>

				<ModalExport
					openModal={this.state.openExportModal}
					user={this.props.auth.user}
					onClose={() => {
						this.setState({ openExportModal: false });
					}}
					exportfct={this.exportCustomerData.bind(this)}
				/>

				<ModalHistory
					openModal={this.state.openExportHistory}
					user={this.props.auth.user}
					companies={this.props.companies}
					allUsers={this.state.allUsers}
					paymentTypes={this.state.paymentTypes}
					onDisplayMessage={this.props.addFlashMessage}
					onClose={() => {
						this.setState({ openExportHistory: false });
					}}
					onError={() => {
						this.props.addFlashMessage({
							type: 'danger',
							text: 'Une erreur est survenue',
							persistent: false,
						});
					}}
				/>

				<ModalDownloadHistory
					openModal={this.state.openDownloadHistory}
					companies={this.props.companies}
					onClose={() => this.setState({ openDownloadHistory: false })}
				/>

				<ModalEmails
					openModal={this.state.openEmails}
					onClose={() => {
						this.setState({ openEmails: false });
					}}
					customerIds={customerIds}
					isSuite={this.state.isSuite}
				/>

				<ModalSettings
					openModal={this.state.openSettings}
					onClose={() => {
						this.setState({ openSettings: false });
					}}
					onSuccess={() => {
						this.props.addFlashMessage({
							type: 'success',
							text: I18n.t('customerAccount.settingsSavedWithSuccess'),
							persistent: false,
						});
						this.getDisplayKeyFigures();
					}}
					onError={() => {
						this.props.addFlashMessage({
							type: 'danger',
							text: I18n.t('accountMigration.error'),
							persistent: false,
						});
					}}
					isSuite={this.state.isSuite}
				/>

				<ModalAccountForm
					openModal={this.state.openAccountForm}
					onClose={() => {
						this.setState({ openAccountForm: false });
					}}
					onSuccess={this.handleFormSuccess}
					accountData={this.state.selectedAccountData}
					isSuite={this.state.isSuite}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	const companies = state.entities.informations.undefined.companies;

	return {
		auth: state.auth,
		companies,
		// La colonne Établissement n'a rien à dire quand le compte n'en a qu'un seul.
		isMultiCompany: Array.isArray(companies) && companies.length > 1,
	};
}

export default connect(mapStateToProps, { addFlashMessage })(CustomerAccount);
